import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=eedfa56c&lang=pug"
import script from "./Menu.vue?vue&type=script&lang=coffee"
export * from "./Menu.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports